import get from 'lodash/get';
import { useIntl } from 'react-intl';

const useConsentOutcomesInfo = consent => {
  const { formatMessage } = useIntl();

  const buttonAccept = formatMessage({
    id: 'common.accept',
  });

  const buttonSelectOption = formatMessage({
    id: 'common.selectOption',
  });

  const isConsentHasMultipleOutcomes = get(consent, 'multipleOutcomes', false);

  const consentOutcomeTitles = get(consent, 'outcomeTitles', []);

  return {
    buttonAccept: isConsentHasMultipleOutcomes
      ? buttonSelectOption
      : buttonAccept,
    consentOutcomeTitles,
    isConsentHasMultipleOutcomes,
  };
};

export default useConsentOutcomesInfo;



// WEBPACK FOOTER //
// ./src/hooks/consents/useConsentOutcomesInfo.js